import * as index from '@syncfusion/ej2-circulargauge';
index.CircularGauge.Inject( index.GaugeTooltip,index.Annotations,index.Legend,index.Print,index.PdfExport,index.ImageExport,index.Gradient);
export * from '@syncfusion/ej2-circulargauge';
